import { CatalogItem, GetReleaseKitResponse } from '../../../../redux/api/fymAPI.types';

/**
 * The tabs of the release page (design assets-rethink b1): Overview, Kit (the keepers, it replaces
 * the Assets tab), Posts (the post files of the song), Release plan (the key stays `plan`, so an old
 * link `tab=plan` opens it) and Auto campaign (`campaign`: the AI reels of the song, one on each
 * day; owner decision 2026-10-12). The query value `?tab=` names the tab. No tab, or an unknown
 * value, opens Overview. The old `tab=assets` (links, emails, the native handoff) opens Kit; the
 * page moves a link to a post file on to Posts (`ReleasePage`).
 */
export type ReleaseTab = 'overview' | 'kit' | 'posts' | 'plan' | 'campaign';

export const RELEASE_TABS: ReadonlyArray<ReleaseTab> = ['overview', 'kit', 'posts', 'plan', 'campaign'];

/** Reads `?tab=`. An unknown or empty value gives Overview; the old `assets` gives Kit. */
export function parseReleaseTab(value: string | undefined | null): ReleaseTab {
  if (value === 'assets') {
    return 'kit';
  }
  return value === 'kit' || value === 'posts' || value === 'plan' || value === 'campaign' ? value : 'overview';
}

/** The element id of a tab panel; the tab button points at it with `aria-controls`. */
export function releaseTabPanelId(tab: ReleaseTab): string {
  return `release-tab-${tab}`;
}

/**
 * What the release page gives each tab body (`overview/OverviewTab.tsx`, `kit/KitTab.tsx`,
 * `plan/PlanTab.tsx`, `campaign/CampaignTab.tsx`). The page renders a tab only when the catalog row and the kit answer are
 * both loaded.
 */
export interface ReleaseTabProps {
  accountId: number;
  /** The catalog row of the song. */
  item: CatalogItem;
  /**
   * `GET /release-kits/:catalogItemUuid`: the kit (null when nothing is made yet), the current
   * asset versions, the newest revisions, the reels of the song and the credit balance. A tab that
   * polls calls `useGetReleaseKitQuery` with the same arguments; RTK Query shares the cache entry.
   */
  release: GetReleaseKitResponse;
}
